import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { useState } from 'react';
import { Button, Card, Input } from '@/components';
import { useAdminAuth } from '@/hooks/useAdminAuth';
import { ApiError } from '@/lib/api';

function Mark() {
  return (
    <div
      className="mx-auto mb-4 flex h-14 w-14 items-center justify-center rounded-2xl bg-primary text-lg font-bold text-white shadow-lg shadow-primary/30"
      aria-hidden
    >
      HL
    </div>
  );
}

function LoginPage() {
  const navigate = useNavigate();
  const { login } = useAdminAuth();
  const [password, setPassword] = useState('');

  const onSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    login.mutate(password, {
      onSuccess: () => {
        void navigate({ to: '/admin', search: { range: '7d' } });
      },
    });
  };

  const err = login.isError
    ? login.error instanceof ApiError
      ? login.error.detail
      : login.error?.message
    : undefined;

  return (
    <div className="relative flex min-h-screen items-center justify-center overflow-hidden p-6">
      <div
        className="pointer-events-none absolute inset-0 bg-gradient-to-br from-primary/15 via-white to-sky-100/40"
        aria-hidden
      />
      <div className="pointer-events-none absolute -right-24 -top-24 h-72 w-72 rounded-full bg-primary/10 blur-3xl" />
      <div className="pointer-events-none absolute -bottom-24 -left-24 h-72 w-72 rounded-full bg-sky-200/30 blur-3xl" />

      <Card className="relative z-10 w-full max-w-sm shadow-xl shadow-gray-900/10">
        <Mark />
        <h1 className="mb-1 text-center text-xl font-semibold tracking-tight text-gray-900">
          Hmonglus Admin
        </h1>
        <p className="mb-6 text-center text-sm text-gray-500">Sign in with your admin passcode</p>
        <form onSubmit={onSubmit} className="space-y-4">
          <Input
            type="password"
            name="passcode"
            autoComplete="current-password"
            label="Passcode"
            autoFocus
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            error={err}
          />
          <Button
            type="submit"
            fullWidth
            loading={login.isPending}
            disabled={!password}
          >
            Sign in
          </Button>
        </form>
      </Card>
    </div>
  );
}

export const Route = createFileRoute('/login')({ component: LoginPage });
